export default "__VITE_ASSET__HQHnBfB3__"